// Mirrors apps/backend-strapi/src/api/gpt-conversation/utils/planPhaseConstants.js
// SKIP_THRESHOLD — keep in sync.
export const SKIP_THRESHOLD = {
  MIN_TYPED_USER_TURNS: 1,
  MIN_USER_TURNS_OR_ATTACHMENTS: 2,
} as const;

export interface SkipIntakeInput {
  typedUserTurns: number;
  totalUserTurns: number;
  attachmentCount: number;
}

export interface SkipIntakeResult {
  canSkip: boolean;
  reason: string | null;
}

export const canSkipIntake = (input: SkipIntakeInput): SkipIntakeResult => {
  const { typedUserTurns, totalUserTurns, attachmentCount } = input;

  if (typedUserTurns < SKIP_THRESHOLD.MIN_TYPED_USER_TURNS) {
    return { canSkip: false, reason: "Tape au moins 1 message" };
  }

  if (totalUserTurns < SKIP_THRESHOLD.MIN_USER_TURNS_OR_ATTACHMENTS && attachmentCount < 1) {
    return {
      canSkip: false,
      reason: "Encore 1 message ou 1 pièce jointe",
    };
  }

  return { canSkip: true, reason: null };
};
